var map = {
	"./blue-light-badge.svg": 37570,
	"./clear.svg": 30812,
	"./customers.svg": 1825,
	"./decline.svg": 68806,
	"./drag-and-drop.svg": 2791,
	"./drag-icon.svg": 33378,
	"./ecomm.svg": 65772,
	"./edit-grey.svg": 40997,
	"./edit.svg": 20936,
	"./editor-afabet.svg": 46681,
	"./editor-bold.svg": 41435,
	"./editor-center.svg": 56050,
	"./editor-image.svg": 53373,
	"./editor-italic.svg": 30074,
	"./editor-justify.svg": 45093,
	"./editor-left.svg": 51941,
	"./editor-link.svg": 6298,
	"./editor-monospace.svg": 31409,
	"./editor-numberic.svg": 97398,
	"./editor-right.svg": 27266,
	"./editor-underline.svg": 56875,
	"./green-check.svg": 11953,
	"./group.svg": 56546,
	"./icon-plus-filled.svg": 42213,
	"./icons-arrow-left.svg": 7815,
	"./icons-arrow2-right.svg": 15973,
	"./icons-assign-thread.svg": 89893,
	"./icons-bag-outlined.svg": 31866,
	"./icons-bell-outlined.svg": 47531,
	"./icons-bookmark-outlined.svg": 14377,
	"./icons-calendar-filled.svg": 31720,
	"./icons-calendar-outlined.svg": 47477,
	"./icons-cap-down-white.svg": 89866,
	"./icons-cap-down.svg": 1730,
	"./icons-card-filled.svg": 46688,
	"./icons-card2-filled.svg": 24303,
	"./icons-chart.svg": 84692,
	"./icons-chevron-left.svg": 66421,
	"./icons-chevron-right.svg": 67325,
	"./icons-clear.svg": 39701,
	"./icons-clock-outlined.svg": 54165,
	"./icons-close.svg": 62335,
	"./icons-close2.svg": 57217,
	"./icons-collapse.svg": 26679,
	"./icons-duplicate.svg": 46134,
	"./icons-edit-filled.svg": 31616,
	"./icons-edit-filled2.svg": 57757,
	"./icons-edit-outlined.svg": 66719,
	"./icons-external-link.svg": 44218,
	"./icons-info-filled.svg": 961,
	"./icons-line-dot.svg": 72655,
	"./icons-location-outlined.svg": 47123,
	"./icons-mail-filled.svg": 49072,
	"./icons-mail2-filled.svg": 34736,
	"./icons-minus.svg": 47124,
	"./icons-minus2.svg": 99663,
	"./icons-more.svg": 89165,
	"./icons-move.svg": 28568,
	"./icons-move2.svg": 79698,
	"./icons-new-message.svg": 81022,
	"./icons-paperplane-filled.svg": 42796,
	"./icons-person-filled.svg": 45922,
	"./icons-person-outlined.svg": 17918,
	"./icons-phone-outlined.svg": 45567,
	"./icons-plus.svg": 12316,
	"./icons-plus2.svg": 16620,
	"./icons-plus3.svg": 49315,
	"./icons-print.svg": 60505,
	"./icons-reconsiliation.svg": 27354,
	"./icons-refresh.svg": 10402,
	"./icons-refund.svg": 46851,
	"./icons-save-solid.svg": 86570,
	"./icons-search1.svg": 96150,
	"./icons-search2.svg": 23871,
	"./icons-share-outlined.svg": 70907,
	"./icons-star-outlined.svg": 81114,
	"./icons-ticket.svg": 38829,
	"./icons-transction-credit-card.svg": 69752,
	"./icons-trash-filled.svg": 85279,
	"./icons-trash-outlined-white.svg": 79671,
	"./icons-trash-outlined.svg": 80567,
	"./icons-voucher.svg": 43332,
	"./iconsBagOutlined.svg": 5694,
	"./iconsBookmarkOutlined.svg": 67023,
	"./iconsCalendarFilled.svg": 9119,
	"./iconsCheck.svg": 68000,
	"./iconsDeviceOutlined.svg": 51500,
	"./iconsLocationOutlined.svg": 53422,
	"./iconsMailOutlined.svg": 71654,
	"./iconsSmileOutlined.svg": 14615,
	"./loading.svg": 95396,
	"./menu-bars.svg": 65023,
	"./minus-circle.svg": 14184,
	"./more-menu.svg": 88634,
	"./move.svg": 62179,
	"./out-of-stock.svg": 99883,
	"./plus_circle.svg": 62149,
	"./table-cells-icon.svg": 17790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75273;